module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av117-d2546d0677fd27991f8be9140d6d7163.jpg";